import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

import { type IPromo } from '../../../../types/promos';

/**
 * @description Событие: клик по карточке/блоку промо в списке ипотечных предложений.
 */
export function trackClickPromoBlock(promo: IPromo, position: number): void {
  const { name } = promo;

  ca('eventSite', {
    action: 'click_block',
    category: 'Promo',
    label: 'mortgage',
    name: 'oldevent',
    products: [createDeveloperProduct({ extra: { mortgage_name: name, position } })],
  });
}
